import { render } from "./MultiselectTags.vue?vue&type=template&id=7d590bbe"
import script from "./MultiselectTags.vue?vue&type=script&lang=js"
export * from "./MultiselectTags.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./MultiselectTags.vue?vue&type=style&index=1&id=7d590bbe&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__